import React from 'react';
import { SectionLabel } from './SectionLabel';
import { AccordionGroup, AccordionRow } from './Accordion';
import { includedGroups } from '../data/whatsIncluded';
export function WhatsIncluded() {
  return <section className="py-32 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto border-t border-ink/10" data-id="element-120" data-mp="3uaf7ajj32igl">
      <SectionLabel title="What's Included" className="mb-16" data-id="element-121" data-mp="251v7vxodv9g" />

      <div className="space-y-20" data-id="element-122" data-mp="pveajrv92ua2">
        {includedGroups.map(group => <AccordionGroup key={group.label} label={group.label} note={group.note} data-id="element-123" data-mp="ptbaef0dvkrm">
            {group.items.map(item => <AccordionRow key={item.title} title={item.title} body={item.body} data-id="element-124" data-mp="gupsmm2qk9rw" />)}
          </AccordionGroup>)}
      </div>
    </section>;
}